/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_cognito_identity_pool_id": "ap-northeast-1:c114de40-e51d-4ab0-97bd-922cb3deabd1",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_pu3t0L0jh",
    "aws_user_pools_web_client_id": "4ohoajlee97iq30d50e4sb5nmc",
    "oauth": {},
    "aws_cloud_logic_custom": [
        {
            "name": "stripeCheckout",
            "endpoint": "https://quf4syfgm2.execute-api.ap-northeast-1.amazonaws.com/prodone",
            "region": "ap-northeast-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://qwagwngec5fhhgri6aypdcezby.appsync-api.ap-northeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-northeast-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-kpw5xkzxtbe47dud4khnxl3hwm"
};


export default awsmobile;
